module.exports = "<div users-wrapper page-class=\"users-instalator\">\n  <ui-view></ui-view>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/instalator/instalator.html
// module id = 102
// module chunks = 0